import { Component, OnInit } from '@angular/core';
import { GlobalsService } from '../../shared/services/globals.service';

@Component({
  selector: 'cp-week-board',
  templateUrl: './week-board.component.html',
  styleUrls: ['./week-board.component.scss']
})
export class WeekBoardComponent implements OnInit {

  constructor(private svc_globals: GlobalsService) { }

  ngOnInit() {
  }
  calendar: string = "https://www.fieldgetics.com/EmployeePortal/DispatchCalendar.aspx?UsrId=" + this.svc_globals.userId + "&CompId=" + this.svc_globals.companyId + "&DskStyle=1";
}